/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  WithTypeName,
  WithTypeNameOptional,
  WithTypeNameMetaI,
  WithTypeNameTrackedI,
} from "./with-type-name";
import { WithTypeNameTracked, WithTypeNameMeta } from "./with-type-name";

/**
 *
 * @export
 * @interface UnifiedClassTypeBase
 */
export interface UnifiedClassTypeBaseOptional extends WithTypeNameOptional {
  /**
   *
   * @type {string}
   * @memberof UnifiedClassTypeBase
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassTypeBase
   */
  prereqMustComplete?: boolean;
}

export interface UnifiedClassTypeBase
  extends UnifiedClassTypeBaseOptional, WithTypeName {
  /**
   *
   * @type {string}
   * @memberof UnifiedClassTypeBase
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassTypeBase
   */
  prereqMustComplete?: boolean;
}

export interface UnifiedClassTypeBaseTrackedI extends WithTypeNameOptional {
  /**
   *
   * @type {string}
   * @memberof UnifiedClassTypeBase
   */
  typeName?: string;
  typeNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeBase
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassTypeBase
   */
  prereqMustComplete?: boolean;
  prereqMustCompleteIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassTypeBase",
  function (model: UnifiedClassTypeBase) {},
);

export type UnifiedClassTypeBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  prereqMustComplete: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var UnifiedClassTypeBaseMeta: UnifiedClassTypeBaseMetaI =
  {} as UnifiedClassTypeBaseMetaI;
UnifiedClassTypeBaseMeta = typeMeta("UnifiedClassTypeBase", {
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  prereqMustComplete: propertyMeta(
    "prereqMustComplete",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = UnifiedClassTypeBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([WithTypeNameMeta]);
  metaI.typeName.inheritedFrom = WithTypeNameMeta.typeName;
});

export class UnifiedClassTypeBaseTracked
  extends WithTypeNameTracked
  implements UnifiedClassTypeBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  prereqMustComplete__I?: boolean = undefined;
  prereqMustCompleteIsSet: boolean = false;
  set prereqMustComplete(v: undefined | boolean) {
    if (v !== undefined) {
      this.prereqMustComplete__I = v;
      this.prereqMustCompleteIsSet = true;
    } else {
      this.prereqMustComplete__I = v || undefined;
      this.prereqMustCompleteIsSet = false;
    }
    this.changeTracker = true;
  }
  get prereqMustComplete() {
    return this.prereqMustComplete__I;
  }
  constructor(config?: UnifiedClassTypeBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: UnifiedClassTypeBaseOptional,
    options?: AssignOptions,
  ): UnifiedClassTypeBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (
      config.prereqMustComplete &&
      this.prereqMustCompleteApplyFilter(optionsRequired.filter)
    ) {
      this.prereqMustComplete = config.prereqMustComplete;
      if (optionsRequired.unassign) this.prereqMustCompleteIsSet = false;
      else this.prereqMustCompleteIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassTypeBaseTrackedI {
    const cloned = {} as UnifiedClassTypeBaseTrackedI;
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.prereqMustCompleteIsSetDeep() &&
      this.prereqMustCompleteApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prereqMustCompleteIsSet = true;
      cloned.prereqMustComplete = this.prereqMustComplete;
    } else {
      //cloned.prereqMustCompleteIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassTypeBaseTrackedI {
    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.prereqMustCompleteApplyFilter(filter))
      this.prereqMustCompleteIsSet = false;

    return this;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeBaseMeta.typeName,
      UnifiedClassTypeBaseMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeBaseMeta.displayOrder,
      UnifiedClassTypeBaseMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  prereqMustCompleteApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeBaseMeta.prereqMustComplete,
      UnifiedClassTypeBaseMeta,
      this.prereqMustComplete,
      this,
    );
  }
  prereqMustCompleteIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.prereqMustCompleteIsSet &&
      this.prereqMustCompleteApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.prereqMustCompleteIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
